// extracted by mini-css-extract-plugin
export default {"engram":"BlmgtRCV","cantDrag":"Q3dOPgdG"};